import {
  ATTRIBUTION_COOKIE_KEY,
  ATTRIBUTION_COOKIE_MAX_AGE_SECONDS,
  type IAttribution,
} from '@repo/analytics';

export function saveAttributionToCookie(attribution: IAttribution): void {
  if (typeof document === 'undefined') {
    return;
  }
  const value = encodeURIComponent(JSON.stringify(attribution));
  const isHttps = window.location.protocol === 'https:';
  const secureFlag = isHttps ? '; Secure' : '';
  // biome-ignore lint/suspicious/noDocumentCookie: client-side first-touch attribution capture before user is signed in
  document.cookie = `${ATTRIBUTION_COOKIE_KEY}=${value}; Max-Age=${ATTRIBUTION_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax${secureFlag}`;
}
